export default __webpack_public_path__ + "static/media/logo-no-text.0df2fa5e.png";